import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import './AdminSidebar.css';

const AdminSidebar = ({ sidebarOpen, onToggle }) => {
    const { t } = useTranslation(['admin', 'common']);
    const navigate = useNavigate();

    const location = useLocation();
    const adminUsername = localStorage.getItem('adminUsername');

    const handleLogout = () => {
        localStorage.removeItem('adminId');
        localStorage.removeItem('adminUsername');
        navigate('/admin/login');
    };

    const isActive = (path) => location.pathname === path;

    return (
        <aside className={`admin-sidebar${sidebarOpen ? ' sidebar-open' : ''}`}>
            <div className="sidebar-brand" onClick={() => navigate('/admin/dashboard')} style={{ cursor: 'pointer' }}>
                <span className="brand-logo">S</span>
                <span className="brand-text">SkillAI<span>Admin</span></span>
            </div>

            <nav className="sidebar-nav">
                <button
                    className={`nav-item ${isActive('/admin/dashboard') ? 'active' : ''}`}
                    onClick={() => navigate('/admin/dashboard')}
                >
                    <i className="icon">📊</i> <span>{t('admin:sidebar.overview', 'Overview')}</span>
                </button>

                <button
                    className={`nav-item ${isActive('/admin/users') ? 'active' : ''}`}
                    onClick={() => navigate('/admin/users')}
                >
                    <i className="icon">👥</i> <span>{t('admin:sidebar.users', 'Users')}</span>
                </button>

                <button
                    className={`nav-item ${isActive('/admin/purchases') ? 'active' : ''}`}
                    onClick={() => navigate('/admin/purchases')}
                >
                    <i className="icon">💰</i> <span>{t('admin:sidebar.purchases', 'Purchases')}</span>
                </button>

                <button
                    className={`nav-item ${isActive('/admin/tests') ? 'active' : ''}`}
                    onClick={() => navigate('/admin/tests')}
                >
                    <i className="icon">📝</i> <span>{t('admin:sidebar.tests', 'Tests')}</span>
                </button>

                <button
                    className={`nav-item ${isActive('/admin/notifications') ? 'active' : ''}`}
                    onClick={() => navigate('/admin/notifications')}
                >
                    <i className="icon">🔔</i> <span>{t('admin:sidebar.pushAlerts', 'Push Alerts')}</span>
                </button>

            </nav>

            <div className="sidebar-footer">
                <div className="admin-profile">
                    <div className="avatar">{adminUsername?.charAt(0).toUpperCase()}</div>
                    <div className="details">
                        <p className="name">{adminUsername}</p>
                        <p className="role">{t('admin:sidebar.administrator', 'Administrator')}</p>
                    </div>

                </div>
                <button onClick={handleLogout} className="logout-action">
                    <i className="logout-icon">🚪</i> <span className="logout-text">{t('admin:sidebar.logout', 'Logout')}</span>
                </button>

            </div>
        </aside>
    );
};

export default AdminSidebar;
